export default __webpack_public_path__ + "static/linia-step-2-5714a6aef20a3bdf7dc36a183bdbc50e.svg";